import { useState } from "react";
import axios from "axios";
import API_URL from "../config";

const UploadForm = ({ onUploadSuccess }) => {
    const [uploading, setUploading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

  const [title, setTitle] = useState("");
  const [publisher, setPublisher] = useState("");
  const [video, setVideo] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);

  const handleUpload = async (e) => {
  e.preventDefault();
  if (!video || !title || !publisher || !thumbnail) {
    alert("Please fill all fields and select a video.");
    return;
  }

  const formData = new FormData();
  formData.append("title", title);
  formData.append("publisher", publisher);
  formData.append("video", video);
  if (thumbnail) { formData.append("thumbnail", thumbnail);  
   }



  try {
      setUploading(true);
      setError(null);
      const res = await axios.post(`${API_URL}/api/videos`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log(res.data);
      setSuccess(true);
      setTitle("");
      setPublisher("");
      setVideo(null);
      setThumbnail(null);

      if (onUploadSuccess) onUploadSuccess(res.data); // notify parent
    } catch (err) {
      console.error(err);
      setError("Upload failed");
    } finally {
      setUploading(false);
    }
};


  return (
        <form onSubmit={handleUpload} className="text-black flex flex-col gap-4">
            <input 
                className="rounded"
                type="text" 
                placeholder="Title" 
                value={title}
                onChange={e => setTitle(e.target.value)} 
            />
            <input 
                className="rounded"
                type="text" 
                placeholder="Publisher" 
                value={publisher}
                onChange={e => setPublisher(e.target.value)} 
            />
            <div>
                <label className="font-bold">Upload Video:</label>
            
            <input 
                className="border border-2 rounded"
                type="file" 
                name="video" 
                accept="video/*" 
                onChange={e => setVideo(e.target.files[0])} 
            />
            </div>
            <div>
                <label className="font-bold">Upload Thumbnail:</label>
            <input 
                className="border border-2 rounded"
                type="file" 
                name="thumbnail" 
                accept="image/*" 
                onChange={e => setThumbnail(e.target.files[0])} 
            />
            </div>
        <p className="text-red-600">*Note: Only videos of 4mb and smaller are supported currently</p>
        <button className="border border-gray-200 rounded bg-gray-200" type="submit" disabled={uploading}>
            {uploading ? "Uploading..." : "Upload"}
        </button>
            {success && <p className="text-green-500">Upload successful!</p>}
            {error && <p className="text-red-500">{error}</p>}
        </form>
  );
};

export default UploadForm;
